module.exports = "<div class=\"row\">\n    <div class=\"col\">\n        <h1><a href=\"/\" style=\"text-decoration:none\">Celebrity Death Pool</a></h1>\n    </div>\n</div>\n<router-outlet></router-outlet>\n<contests></contests>"


//////////////////
// WEBPACK FOOTER
// /Users/william/Documents/gitlab/stovokor/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main